export default {
    portfolioTemplateData(state) {
        let portfolioTemplateId = state.portfolio.templateSettings.templateId ? state.portfolio.templateSettings.templateId : state.portfolio.templateSettings.theme.replace("profile_", "").replace('_old', '');
        return state.portfolioTemplates.find(template => template.templateId === portfolioTemplateId)
    },
    getTemplateForPortfolio: (state) => (portfolio) => {
        let portfolioTemplateId = portfolio.templateSettings.templateId ? portfolio.templateSettings.templateId : portfolio.templateSettings.theme.replace("profile_", "").replace('_old', '');
        return state.portfolioTemplates.find(template => template.templateId === portfolioTemplateId)
    },
    getDefaultTemplateStyle: (state) => (templateId) => {
        return state.portfolioTemplateStyles.find(template => template.templateId === templateId);
    }
}